import { render, staticRenderFns } from "./MinimalMedicalCertificate.vue?vue&type=template&id=f20c4948&scoped=true"
import script from "./MinimalMedicalCertificate.vue?vue&type=script&lang=ts"
export * from "./MinimalMedicalCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20c4948",
  null
  
)

export default component.exports